// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ob4gl{color:#fff;display:grid;column-gap:8px;align-items:flex-start;max-inline-size:1024px;grid-template-areas:". . closeButton" "arrowback image arrowforward" "arrowback caption arrowforward"}.CFHg7{grid-area:closeButton;place-self:flex-start}.yLZ8V,.xPoMo,.CFHg7{color:#fff}.yLZ8V,.xPoMo{align-self:center}.yLZ8V{justify-self:flex-end;grid-area:arrowback}.xPoMo{justify-self:flex-start;grid-area:arrowforward}.MR4Yu{display:contents}.MR4Yu img{grid-area:image;block-size:100%;inline-size:100%;object-fit:contain;background-color:#bfbfd0;transition:opacity .6s ease 0s;will-change:opacity}.MR4Yu .FQ9HO{grid-area:caption;block-size:100%;display:flex;justify-content:space-between;align-items:flex-start;gap:64px;background-color:#282863;border-end-start-radius:8px;border-end-end-radius:8px;padding:24px 32px}.oY1JP{align-self:flex-end}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"modalRoot": `ob4gl`,
	"closeButton": `CFHg7`,
	"arrowBackward": `yLZ8V`,
	"arrowForward": `xPoMo`,
	"figure": `MR4Yu`,
	"caption": `FQ9HO`,
	"counter": `oY1JP`
};
export default ___CSS_LOADER_EXPORT___;
